import { compose } from "recompose";

import Target2SellCarousel, {
  IProps,
} from "../../../../components/Target2SellCarousel/Target2SellCarousel.component";
import environment from "../../../../environment";
import withT2sProducts, {
  IWithT2sProducts,
} from "../../../../hoc/repository/withT2sProducts/withT2sProducts";

export type IConnectedProps = IWithT2sProducts;

export type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(
  withT2sProducts(environment.T2S.RECO_PAGES.HOME_SELECTION)
)(Target2SellCarousel);
